import { fetch } from "../services/api";

const onChangeEvent = (roomOccupationId, cb) => {
    console.log("16ago - events - roomOccupation - onChangeEvent")
    // return fetch(onRoomOccupationChange, { id: roomOccupationId }).subscribe({
    //     next: (r) => {
    //         if (r.value?.data?.onRoomOccupationChange) {
    //             cb(r.value.data.onRoomOccupationChange)
    //         } else {
    //             console.error(r)
    //         }
    //     },
    //     error: (err) => console.error(err)
    // });
}

const getAddDevicePath = (roomOccupationId) => {
    console.log('TODO - getAddDevicePath')
    // return fetch(getRoomOccupationSecurityCode, { id: roomOccupationId })
    //     .then(r => {
    //         if (r.data?.getRoomOccupation?.CheckIn?.id && r.data?.getRoomOccupation?.CheckIn?.securityCode) {
    //             return `/checkin/identify/${r.data.getRoomOccupation.CheckIn.id}_${r.data.getRoomOccupation.CheckIn.securityCode}`
    //         }
    //         throw new Error('user-getAddDevicePath-error')
    //     }).catch((response) => {
    //         console.log('error', response)
    //     });
}

const setDoNotDisturbMode = (roomOccupationId, state) => {
    console.log('TODO - setDoNotDisturbMode')
    // return fetch(updateRoomOccupation, { input: { id: roomOccupationId, doNotDisturb: state } })
    //     .then(r => {
    //         return r.data.updateRoomOccupation;
    //     }).catch((err) => {
    //         console.log('error - setDoNotDisturbMode', err)
    //     });
}

const refreshBalanceAndInvoices = (roomOccupationId) => {
    console.log('TODO - refreshBalanceAndInvoices')
    // return fetch(getRoomOccupationBalanceAndInvoices, { id: roomOccupationId })
    //     .then(r => {
    //         return {
    //             balance: r.data.getRoomOccupation.balance,
    //             invoices: r.data.getRoomOccupation.invoices
    //         }
    //     }).catch((err) => {
    //         console.log('error - refreshBalance', err)
    //     });
}

const validateCheckOut = (roomOccupationId, hotelId) => {
    // TODO:::: resolver mejor
    console.log('TODO - validateCheckOut')
    // return fetch(partnersIntegration, { event: JSON.stringify({
    //     "partner": 'apaleo',
    //     "entity": "roomoccupations",
    //     "action": "validate-checkout",
    //     "hotelId": hotelId,
    //     "id": roomOccupationId
    // })})
    //     .then(r => {
    //         return {
    //             status: r.data.PartnersIntegration.status,
    //             data: r.data.PartnersIntegration.data
    //         }
    //     }).catch((err) => {
    //         console.log('error - validateCheckOut', err)
    //     });
}

const checkOut = (roomOccupationId, hotelId, invoiceData) => {
    // TODO:::: resolver mejor
    console.log('TODO - checkOut')
    // return fetch(partnersIntegration, { event: JSON.stringify({
    //     "partner": 'apaleo',
    //     "entity": "roomoccupations",
    //     "action": "checkout",
    //     "hotelId": hotelId,
    //     "id": roomOccupationId,
    //     "invoiceData": JSON.stringify(invoiceData)
    // })})
    //     .then(r => {
    //         return {
    //             status: r.data.PartnersIntegration.status === "true",
    //             data: r.data.PartnersIntegration.data
    //         }
    //     }).catch((err) => {
    //         console.log('error - checkOut', err)
    //     });
}

// const onEvolutionChangeEvent = (roomOccupationId, cb) => {
//     return fetch(onSomeRequestEvolutionRoomOccupationChange, { roomOccupationId: roomOccupationId }).subscribe({
//         next: (r) => {
//             console.log('99999', r)
//             // if (r.value?.data?.onCheckInChange) {
//             //     cb(r.value.data.onCheckInChange)
//             // } else {
//             //     console.error(r)
//             // }
//         },
//         error: (err) => console.error(err)
//     });
// }

export {
    onChangeEvent,
    getAddDevicePath,
    setDoNotDisturbMode,
    refreshBalanceAndInvoices,
    validateCheckOut,
    checkOut
}